'use client'

import { Dialog } from '@vinted/web-ui'

import { ScrollableArea } from '@marketplace-web/common-components/scrollable-area-ui'

import { useSellerProtectionScreenTracking } from '../../hooks/useSellerProtectionScreenTracking'
import NavigationCloseButton from './NavigationCloseButton'
import CloseButton from './CloseButton'
import SellerProtectionInformation from '../SellerProtectionInformation'

type Props = {
  transactionId: string | null | undefined
  transactionStatus: number | null | undefined
  shipmentStatus: number | null | undefined
  isVisible: boolean
  onClose: () => void
}

const SellerProtectionInformationDialog = ({
  transactionId,
  transactionStatus,
  shipmentStatus,
  isVisible,
  onClose,
}: Props) => {
  const { finishSellerProtectionScreenViewing } = useSellerProtectionScreenTracking({
    transactionStatus,
    shipmentStatus,
    isVisible,
  })

  const handleOnClose = () => {
    finishSellerProtectionScreenViewing()
    onClose()
  }

  return (
    <Dialog hasScrollableContent show={isVisible} testId="seller-protection-information-dialog">
      <div className="u-fill-width">
        <NavigationCloseButton handleClose={handleOnClose} />
        <ScrollableArea>
          <SellerProtectionInformation
            transactionId={transactionId}
            transactionStatus={transactionStatus}
            shipmentStatus={shipmentStatus}
          />
          <CloseButton handleClose={handleOnClose} />
        </ScrollableArea>
      </div>
    </Dialog>
  )
}

export default SellerProtectionInformationDialog
